import { IconProps } from './IconProps';

export const LogoStrokedGradient = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      xmlns="http://www.w3.org/2000/svg"
      width="65"
      height="47"
      viewBox="0 0 65 47"
      fill="none"
    >
      <path
        d="M46.6374 18.8622L62.7825 33.446L51.8605 45.382L33.17 28.5016L32.4997 27.8962L31.8294 28.5016L13.1395 45.382L2.21748 33.446L18.3626 18.8622L20.2912 17.1201L17.6923 17.1201L8.54635 17.1202V1H56.4311V17.1202L47.3077 17.1201L44.7088 17.1201L46.6374 18.8622Z"
        stroke="url(#paint0_linear_1_85)"
        strokeWidth="2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1_85"
          x1="-6.91424"
          y1="-11.9224"
          x2="64.1997"
          y2="44.604"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.213542" stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

